export const REDUCER_NAME = 'sources';
